import {
  CopyOutlined,
  DeleteOutlined,
  FileExcelOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  Modal,
  message,
} from 'antd';
import dayjs from 'dayjs';
import 'jspdf-autotable';
import moment from 'moment';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { ReactComponent as PlanPrintIcon } from '../../Images/SimplePrintIcon.svg';
import {
  deleteBundleOutwardList,
  fetchBundleOutWardList,
  resetBundleOutWardList,
  fetchBundleOutWardListByItem
} from '../../slices/bundleoutward';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import { createActivityLog } from '../../slices/activity-log';

function BundleOutWardList() {
  let navigate = useNavigate();
  const defaultStart = dayjs().startOf('month');
  const defaultEnd = dayjs();
  const { user: currentUser } = useSelector(state => state.auth);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(100);
  const [search, setSearch] = useState(
    localStorage.getItem('die_text_search_bundleOutWard') || '',
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('die_text_search_bundleOutWard') || '',
  );

  const storedStart = localStorage.getItem('bundleOutward_start_date');
  const storedEnd = localStorage.getItem('bundleOutward_end_date');
  const [start_date, set_start_date] = useState(
    storedStart ? dayjs(storedStart, 'DD-MM-YYYY') : defaultStart,
  );
  const [end_date, set_end_date] = useState(
    storedEnd ? dayjs(storedEnd, 'DD-MM-YYYY') : defaultEnd,
  );
  const ipAddress = useSelector(state => state.ip.ipAddress);
  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);

  const {
    data = [],
    status,
    Outwardcount,
  } = useSelector(state => state.bundleoutward);


  useEffect(() => {
    const fetchAllData = async () => {
      dispatch(resetBundleOutWardList());
      if (search.length) {
        dispatch(
          fetchBundleOutWardList({
            page,
            pagesize,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
          }),
        );
      } else {
        dispatch(
          fetchBundleOutWardList({
            page,
            pagesize,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
            ...(start_date && { start_date: dayjs(start_date).format('DD-MM-YYYY') }),
            ...(end_date && { end_date: dayjs(end_date).format('DD-MM-YYYY') }),
          }),
        );
      }


    };

    fetchAllData();
  }, [search, orderBy, start_date, end_date, page, pagesize]);

  const [checkedList, setCheckedList] = useState([
    'id',
    'slip_no',
    'SrNo',
    'work_order_number',
    'date_prepared',
    'shift',
    'work_order_number',
    'customer_name',
    'customer_name',
    'transporter_name',
    'vehicle_no',
    'total_weight',
    'total_pieces',
    'total_bundles',
    'packing_type',
    'status',
    'approved',
    'remarks',
    'action',
  ]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const handleEdit = data => {
    navigate(`/edit-outward/${data}`);
  };

  const handleDelete = async (record) => {
    if (!record?.id) {
      message.error('Missing ID for deletion!');
      return;
    }
    if (record?.status === "Warehouse" && record?.approved) {
      confirmDelete(record?.id);
    } else if (record?.status === "Customer" && record?.approved) {
      confirmDelete(record?.id);
    } else {

      const hasValues = Number(record?.total_bundles) !== 0 && Number(record?.total_pieces) !== 0 && Number(record?.total_weight) !== 0;
      if (hasValues) {

        const summaryResponse = await dispatch(
          fetchBundleOutWardListByItem({
            workOrderId: record?.work_order_id,
            page: 1,
            pagesize: 1000,
            bundleOutwardId: record?.id,
          }),
        ).unwrap();

        if (summaryResponse?.results?.data?.length > 0) {
          Modal.warning({
            title: `Stock Will Be Reversed for Listed Items Of Slip No.${record?.slip_no}`,
            width: 720,
            icon: <InfoCircleOutlined style={{ color: "#faad14" }} />,
            okText: "Final Delete",
            cancelText: "Cancel",
            okCancel: true,
            maskClosable: false,
            onOk: () => {
              confirmDelete(record?.id);
            },
            onCancel: () => {
              message.info("Delete cancelled");
            },
            content: (
              <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "10px" }}>
                <p>
                  These items have associated stock movements. Deleting this record will reverse those
                  stock changes. Please review the items below before confirming deletion.
                </p>

                <ul style={{ paddingTop: 20 }}>
                  {summaryResponse?.results?.data?.filter(item => Number(item.added_bundles) > 0)?.map((item, index) => (
                    <li
                      key={item.workorder_detail_id}
                      style={{ marginTop: index === 0 ? 0 : 10, lineHeight: "22px" }}
                    >
                      <b>{index + 1}.</b> {item.item_description}{" "}
                      (Added Bundles: {item.added_bundles}).
                    </li>
                  ))}
                </ul>
              </div>
            ),
          });
        }
      } else {
        console.group("Diret Delete");
        confirmDelete(record?.id);
      }
    }
  };

  const confirmDelete = async (id) => {
    try {
      dispatch(deleteBundleOutwardList(id))
        .unwrap()
        .then(response => {
          if (response?.success) {
            dispatch(resetBundleOutWardList());
            dispatch(
              fetchBundleOutWardList({
                page,
                pagesize,
                ...(search && { search: search }),
                ...(orderBy && { ordering: orderBy }),
                ...(start_date && { start_date: dayjs(start_date).format('DD-MM-YYYY') }),
                ...(end_date && { end_date: dayjs(end_date).format('DD-MM-YYYY') }),
              }),
            );
          } else {

            if (response?.message) {
              Modal.warning({
                title: `Action Restricted: Bundles Already Delivered`,
                width: 720,
                icon: <InfoCircleOutlined style={{ color: "#faad14" }} />,
                okText: "OK",
                cancelButtonProps: { style: { display: "none" } },
                maskClosable: false,
                onOk: () => {
                  console.log("OK clicked");
                },
                content: (
                  <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "10px" }}>
                    <p>
                      The selected bundles have been dispatched and delivered to the customer.
                      For audit and stock control reasons, delivered bundles cannot be deleted.
                    </p>

                    <ul style={{ paddingTop: 20 }}>
                      {response.message?.map((item, index) => (
                        <li
                          key={index}
                          style={{
                            marginTop: index === 0 ? 0 : 10,
                            lineHeight: "22px",
                          }}
                        >
                          <b>{index + 1}.</b> {item}{" "}
                        </li>
                      ))}
                    </ul>
                  </div>
                ),
              });
            }
          }

        })
        .catch(error => {
          const err = error;  // IMPORTANT FIX

          if (err?.message) {
            const msg = Array.isArray(err.message)
              ? err.message.join(', ')
              : err.message;

            message.error(msg);
            return;
          }

          if (error instanceof Error) {
            message.error(error.message);
            return;
          }

          message.error('An unknown error occurred.');
        });
    } catch (err) {
      message.error("Failed to delete record");
    }
  };

  const handlePrint = id => {
    navigate(`/print-bundle-outword/${id}`);
  };

  const columns = [
    {
      title: 'Sr. No.',
      key: 'SrNo',
      width: 70,
      className: 'sr-no-column',
      render: (text, record, index) => (page - 1) * pagesize + index + 1,
    },
    {
      title: 'Slip No.',
      dataIndex: 'slip_no',
      key: 'slip_no',
      width: 120,
      render: slip_no => {
        return <span>{slip_no ?? 'N/A'}</span>;
      },
    },
    {
      title: 'Work Order Number',
      dataIndex: 'work_order_number',
      key: 'work_order_number',
      width: 120,
      render: work_order_number => <span>{work_order_number ?? 'N/A'}</span>,
    },
    {
      title: 'Date Prepared',
      dataIndex: 'date_prepared',
      key: 'date_prepared',
      width: 160,
      render: date_prepared => {
        return (
          <span>
            {date_prepared
              ? dayjs(date_prepared).format('DD-MM-YYYY h:mm A').toLowerCase()
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Shift',
      dataIndex: 'shift',
      key: 'shift',
      width: 80,
      sorter: true,
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: 160,
      render: customer_name => {
        return <span>{customer_name || 'N/A'} </span>;
      },
    },
    {
      title: 'Total Weight (kg)',
      dataIndex: 'total_weight',
      key: 'total_weight',
      sorter: true,
      width: 130,
      render: total_weight => {
        return (
          <span>
            {total_weight !== null && total_weight !== undefined
              ? total_weight
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Total Pieces',
      dataIndex: 'total_pieces',
      key: 'total_pieces',
      width: 80,
      render: total_pieces => {
        return <span>{total_pieces ?? 'N/A'} </span>;
      },
    },
    {
      title: 'Total Bundles',
      dataIndex: 'total_bundles',
      key: 'total_bundles',
      width: 80,
      render: total_bundles => {
        return <span>{total_bundles ?? 'N/A'} </span>;
      },
    },
    {
      title: 'Transpoter Name',
      dataIndex: 'transporter_name',
      key: 'transporter_name',
      width: 150,
      render: transporter_name => {
        return <span>{transporter_name ?? 'N/A'}</span>;
      },
    },
    {
      title: 'Vehicle No.',
      dataIndex: 'vehicle_no',
      key: 'vehicle_no',
      width: 110,
      render: (_, record) => (
        <span>{record?.vehicle_details?.vehicle_no ?? 'N/A'}</span>
      ),
    },
    {
      title: 'Packing Type',
      dataIndex: 'packing_type',
      key: 'packing_type',
      width: 180,
      render: (_, record) => {
        const packingModes = record?.packing_mode_details || [];
        return packingModes.length
          ? packingModes.map(pm => pm.name).join(', ')
          : 'N/A';
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 110,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          {currentUser.permissions.permissions.bundle_outward.includes(
            'print_bundle_outward_copy',
          ) &&
            (record.approved === true ? (
              <Tooltip title="Print">
                <PlanPrintIcon
                  style={{ cursor: 'pointer' }}
                  onClick={() => handlePrint(record.id)}
                />
              </Tooltip>
            ) : (
              <Tooltip title="Not Approved">
                <InfoCircleOutlined
                  style={{ color: '#faad14', cursor: 'pointer' }}
                  onClick={() => handleEdit(record.id)}
                />
              </Tooltip>
            ))}
          {currentUser.permissions.permissions.bundle_outward.includes(
            'delete_bundleoutward',
          ) && (
              <Link>
                <Tooltip title="Delete">
                  <Popconfirm
                    title="Are you sure you want to delete this record?"
                    onConfirm={() => handleDelete(record)}
                    onCancel={() => message.info('Action cancelled')}
                    okText="Yes"
                    cancelText="No"
                  >
                    <DeleteOutlined
                      style={{ cursor: 'pointer', fontSize: '18px' }}
                    />
                  </Popconfirm>
                </Tooltip>
              </Link>
            )}
        </Space>
      ),
    },
  ];
  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const dataSource = Array.isArray(data)
    ? data.map((item, index) => ({
      ...item,
      key: item.id || index,
      SrNo: (page - 1) * pagesize + index + 1,
    }))
    : [];

  const handleTableChange = async (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    if (pagination?.pageSize) setPageSize(pagination.pageSize);
    if (pagination?.current) setPage(pagination.current);
  };

  const debounceTimeout = useRef(null);

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  // Debounced search handler
  const debouncedSearch = useCallback(
    debounce(value => {
      dispatch(resetBundleOutWardList());
      setSearch(value);
      localStorage.setItem('bundle_inward', value);
    }, 500),
    [dispatch],
  );

  const handleSearch = e => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('die_text_search_bundleOutWard', value);
    debouncedSearch(value);
  };
  // const debouncedAPICall = useMemo(
  //   () =>
  //     debounce(query => {
  //       if (query.length >= 3) {
  //         dispatch(fetchBundleOutWardList({ search: query }));
  //         localStorage.setItem('die_text_search_bundleOutWard', query);
  //       }
  //     }, 100),
  //   [],
  // );

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);


  const copyTableData = async () => {
    const count = Outwardcount || 0;
    if (count > 0) {
      const finalRes = await dispatch(
        fetchBundleOutWardList({
          page: 1,
          pagesize: count,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
          ...(start_date && { start_date: dayjs(start_date).format('DD-MM-YYYY') }),
          ...(end_date && { end_date: dayjs(end_date).format('DD-MM-YYYY') }),
        }),
      );

      const freshData = finalRes?.payload?.results?.data || [];

      try {
        const srNoColumnIndex = filteredColumns.findIndex(
          column =>
            column.title === 'Sr. No.' ||
            column.dataIndex === 'srNo' ||
            column.key === 'srNo',
        );

        const headers = filteredColumns
          .map(column => column.title)
          .filter(title => title !== 'Action');

        const rows = freshData.map((record, index) => {
          const rowData = filteredColumns
            .map((column, colIndex) => {
              if (column.key === 'action') return null;

              let value;
              if (column.render) {
                const renderedValue = column.render(
                  record[column.dataIndex],
                  record,
                );
                value = React.isValidElement(renderedValue)
                  ? renderedValue.props.children || ''
                  : renderedValue || '';
                if (
                  typeof value === 'string' &&
                  /\d{2}-\d{2}-\d{4} \d{1,2}:\d{2} (am|pm)/i.test(value)
                ) {
                  value = `${value}`;
                }
              } else if (column.dataIndex && column.dataIndex.includes('.')) {
                const keys = column.dataIndex.split('.');
                value = keys.reduce((val, key) => val?.[key], record);
              } else {
                value = record[column.dataIndex];
              }
              if (Array.isArray(value)) {
                value = value
                  .filter(
                    v =>
                      v !== undefined && v !== null && String(v).trim() !== '',
                  )
                  .join(' | ');
              }
              if (typeof value === 'number') {
                value = value.toString(); // Not value.toLocaleString()
              }
              if (srNoColumnIndex !== -1 && colIndex === srNoColumnIndex) {
                value = (index + 1).toString();
              }

              return value || '';
            })
            .filter(cell => cell !== null);

          return rowData.join('\t');
        });

        const tableData = [headers.join('\t'), ...rows].join('\n');

        await navigator.clipboard.writeText(tableData);
        message.success('Table data copied to clipboard');
      } catch (error) {
        message.error('Failed to copy table data');
        console.error('Copy error:', error);
      }
    }
  };

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'pan_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'workorder__order_no';
    }
    if (sortField === 'pan_number' && sortOrder === 'descend') {
      sortingEnumKey = '-workorder__order_no';
    }
    if (sortField === 'gstin_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer__customer_name';
    }
    if (sortField === 'gstin_number' && sortOrder === 'descend') {
      sortingEnumKey = '-customer__customer_name';
    }
    if (sortField === 'slip_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'slip_no';
    }
    if (sortField === 'slip_no' && sortOrder === 'descend') {
      sortingEnumKey = '-slip_no';
    }
    if (sortField === 'date_prepared' && sortOrder === 'ascend') {
      sortingEnumKey = 'date_prepared';
    }
    if (sortField === 'date_prepared' && sortOrder === 'descend') {
      sortingEnumKey = '-date_prepared';
    }
    if (sortField === 'shift' && sortOrder === 'ascend') {
      sortingEnumKey = 'shift';
    }
    if (sortField === 'shift' && sortOrder === 'descend') {
      sortingEnumKey = '-shift';
    }
    if (sortField === 'total_weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_weight';
    }
    if (sortField === 'total_weight' && sortOrder === 'descend') {
      sortingEnumKey = '-total_weight';
    }
    if (sortField === 'total_pieces' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_pieces';
    }
    if (sortField === 'total_pieces' && sortOrder === 'descend') {
      sortingEnumKey = '-total_pieces';
    }
    if (sortField === 'total_bundles' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_bundles';
    }
    if (sortField === 'total_bundles' && sortOrder === 'descend') {
      sortingEnumKey = '-total_bundles';
    }
    if (sortField === 'transporter_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'transporter_name';
    }
    if (sortField === 'transporter_name' && sortOrder === 'descend') {
      sortingEnumKey = '-transporter_name';
    }
    if (sortField === 'vehicle_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'vehicle_no';
    }
    if (sortField === 'vehicle_no' && sortOrder === 'descend') {
      sortingEnumKey = '-vehicle_no';
    }
    if (sortField === 'status' && sortOrder === 'ascend') {
      sortingEnumKey = 'status';
    }
    if (sortField === 'status' && sortOrder === 'descend') {
      sortingEnumKey = '-status';
    }
    if (sortField === 'item_description' && sortOrder === 'ascend') {
      sortingEnumKey = 'item_description';
    }
    if (sortField === 'item_description' && sortOrder === 'descend') {
      sortingEnumKey = '-item_description';
    }
    return sortingEnumKey;
  };

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    localStorage.removeItem('die_text_search_bundleOutWard');
    localStorage.removeItem('die_group_search_bundleOutWard');
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="slip_no">Slip No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="work_order_number">Work Order No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="date_prepared">Date Prepared</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="shift">Shift</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_name">Customer Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_weight">Total Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_pieces">Total Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_bundles">Total Bundles</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="transporter_name">Transporter Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="vehicle_no">Vehicle No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packing_type">Packing Type</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  const allCsvColumns = [
    { header: 'Sr. No.', dataKey: 'SrNo', field: 'SrNo' },
    { header: 'Slip No.', dataKey: 'slip_no', field: 'slip_no' },
    {
      header: 'Work Order No.',
      dataKey: 'work_order_number',
      field: 'work_order_number',
    },
    { header: 'Date Prepared', dataKey: 'date_prepared', field: 'date_prepared' },
    { header: 'Shift', dataKey: 'shift', field: 'shift' },
    { header: 'Customer Name', dataKey: 'customer_name', field: 'customer_name' },
    {
      header: 'Total Weight(Kg)',
      dataKey: 'total_weight',
      field: 'total_weight',
    },
    { header: 'Total Pieces', dataKey: 'total_pieces', field: 'total_pieces' },
    { header: 'Total Bundles', dataKey: 'total_bundles', field: 'total_bundles' },
    {
      header: 'Transporter Name',
      dataKey: 'transporter_name',
      field: 'transporter_name',
    },
    { header: 'Vehicle No.', dataKey: 'vehicle_no', field: 'vehicle_no' },
    { header: 'Paking Type', dataKey: 'packing_type', field: 'packing_type' },
    { header: 'Status', dataKey: 'status', field: 'status' },
  ];
  const csvHeaders = allCsvColumns
    .filter(col => checkedList.includes(col.field)) // Filter only selected columns
    .map(col => ({
      label: col.header, // CSV column header
      key: col.dataKey, // Corresponding data key
    }));
  const csvLinkRef = useRef();
  const [csvData, setCsvData] = useState([]);
  const handleCSV = async () => {
    const count = Outwardcount || 0;

    if (count > 0) {
      const response = await dispatch(
        fetchBundleOutWardList({
          page: 1,
          pagesize: count,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
          ...(start_date && { start_date: dayjs(start_date).format('DD-MM-YYYY') }),
          ...(end_date && { end_date: dayjs(end_date).format('DD-MM-YYYY') }),
        }),
      );

      const freshData = response?.payload?.results.data || [];

      const csvListData = freshData.map((item, index) => {
        const row = {
          SrNo: index + 1,
        };

        allCsvColumns
          .filter(col => checkedList.includes(col.field))
          .forEach(col => {
            if (col.field === 'SrNo') return;

            switch (col.field) {
              case 'slip_no':
                row.slip_no = item?.slip_no || 'N/A';
                break;
              case 'work_order_number':
                row.work_order_number = item?.work_order_number || 'N/A';
                break;
              case 'date_prepared':
                row.date_prepared = item?.date_prepared
                  ? dayjs(item?.date_prepared)
                    .format('DD-MM-YYYY h:mm A')
                    .toLowerCase()
                  : 'N/A';
                break;
              case 'shift':
                row.shift = item?.shift || 'N/A';
                break;
              case 'customer_name':
                row.customer_name = item?.customer_name || 'N/A';
                break;
              case 'transporter_name':
                row.transporter_name = item?.transporter_name || 'N/A';
                break;
              case 'vehicle_no':
                 row.vehicle_no = item?.vehicle_details?.vehicle_no || 'N/A';
                break;

              case 'total_weight':
                row.total_weight = item?.total_weight || 0;
                break;
              case 'total_pieces':
                row.total_pieces = item?.total_pieces || 0;
                break;
              case 'total_bundles':
                row.total_bundles = item?.total_bundles || 0;
                break;
              case 'packing_type':
                try {
                  const packingModes = item?.packing_mode_details || [];;
                  row.packing_type = packingModes.map(pm => pm.name).join(', ');
                } catch (e) {
                  row.packing_type = 'N/A';
                }
                break;
              case 'status':
                row.status = item?.status || 'N/A';
                break;
              default:
                row[col.dataKey] = 'N/A';
            }
          });

        return row;
      });

      setCsvData(csvListData);
      setTimeout(() => {
        csvLinkRef.current?.link.click();
      }, 500);
    }
  };

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Bundle OutWard',
        ip_address: ipAddress,
        discription: 'Bundle outward excel download successfully!',
      }),
    );
  };

  return (
    <div className='mainwrap'>
      <div className="sticyaction pb-0">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0"
            justify="space-between"
            align="middle"
            gutter={[5, 5]}
          >
            <Col >
              <h2 style={{ margin: 0 }}>Bundle Outward</h2>
              <div className="bredcrumbwrp">
                <Link onClick={() => navigate(-1)} className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Bundle Outward' },
                  ]}
                />
              </div>
            </Col>
            <Col >
              <div className="flex justify-end items-end gap-4 flex-wrap">
                <Form
                  layout="vertical"
                  autoComplete="off"
                  form={form}
                  className="flex items-end gap-4"
                  initialValues={{
                    start_date: start_date,
                    end_date: end_date,
                  }}
                >
                  <Form.Item
                    name="start_date"
                    label="Start Date"
                    className="mb-0"
                  >
                    <DatePicker
                      style={{ width: 150 }}
                      format="DD-MM-YYYY"
                      value={
                        start_date ? moment(start_date, 'DD-MM-YYYY') : null
                      }
                      onChange={(date) => {
                        set_start_date(date);
                        localStorage.setItem(
                          'bundleOutward_start_date',
                          date.format('DD-MM-YYYY'),
                        );
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="end_date"
                    label="End Date"
                    className="mb-0"
                  >
                    <DatePicker
                      style={{ width: 150 }}
                      format="DD-MM-YYYY"
                      value={end_date ? moment(end_date, 'DD-MM-YYYY') : null}
                      disabledDate={current =>
                        start_date
                          ? current.isBefore(
                            moment(start_date, 'DD-MM-YYYY'),
                            'day',
                          ) ||
                          current.isSame(
                            moment(start_date, 'DD-MM-YYYY'),
                            'day',
                          )
                          : false
                      }
                      onChange={(date) => {
                        set_end_date(date);
                        localStorage.setItem(
                          'bundleOutward_end_date',
                          date.format('DD-MM-YYYY'),
                        );
                      }}
                    />
                  </Form.Item>
                  {(start_date || end_date) && (
                    <Form.Item className="mb-0">
                      <Button
                        type="primary"
                        onClick={() => {
                          setPage(1);
                          dispatch(resetBundleOutWardList());
                          form.resetFields();
                          set_start_date(null);
                          set_end_date(null);
                          form.setFieldsValue({
                            start_date: null,
                            end_date: null,
                          });
                          localStorage.removeItem(
                            'bundleOutward_start_date',
                          );
                          localStorage.removeItem('bundleOutward_end_date');
                        }}
                      >
                        Reset
                      </Button>
                    </Form.Item>
                  )}
                </Form>
                <Space size="small">
                  <Input
                    placeholder="Search"
                    className="searchbox"
                    prefix={<SearchOutlined />}
                    value={search}
                    onChange={handleSearch}
                    style={{ width: 200 }}
                  />
                  <Tooltip title="Filter">
                    <Button
                      type="primary"
                      disabled={!search && !orderBy}
                      className="iconlink"
                      onClick={resetFilter}
                    >
                      <FilterIcon />
                    </Button>
                  </Tooltip>
                  {currentUser.permissions.permissions.bundle_outward.includes(
                    'download_bundle_outward_excel_copy',
                  ) && (
                      <Tooltip placement="top" title={'Export Excel'}>
                        <>
                          <Button
                            type="primary"
                            className="iconlink"
                            style={{ width: '10px' }}
                            onClick={handleCSV}
                          >
                            <FileExcelOutlined onClick={activityLog} />
                          </Button>
                          <CSVLink
                            data={csvData}
                            filename={'BundleOutWardList.csv'}
                            headers={csvHeaders}
                            className="hidden"
                            ref={csvLinkRef}
                          >
                            Download
                          </CSVLink>
                        </>
                      </Tooltip>
                    )}
                  {currentUser.permissions.permissions.bundle_outward.includes(
                    'view_bundleoutward',
                  ) && (
                      <Tooltip title="Copy">
                        <Button
                          type="primary"
                          className="iconlink p-4"
                          onClick={copyTableData}
                        >
                          <CopyOutlined />
                        </Button>
                      </Tooltip>
                    )}
                  {currentUser.permissions.permissions.bundle_outward.includes(
                    'add_bundleoutward',
                  ) && (
                      <Link to="/add-outward">
                        <Tooltip title="Add Bundle OutWard">
                          <Button type="primary" icon={<PlusOutlined />}>
                            Add Bundle OutWard
                          </Button>
                        </Tooltip>
                      </Link>
                    )}
                  <div className="gridiconswrap">
                    <Tooltip placement="topLeft" title="Column Filter Options">
                      <Dropdown
                        overlay={columnMenu}
                        trigger={['click']}
                        placement="bottomRight"
                        visible={dropdownVisible}
                        onVisibleChange={setDropdownVisible}
                      >
                        <Button
                          type="primary"
                          icon={<ColumnList />}
                          onClick={e => e.preventDefault()}
                        />
                      </Dropdown>
                    </Tooltip>
                  </div>
                </Space>
              </div>
            </Col>
          </Row>
        </div>
      </div>


      <div className='tablewrp'>
        <Table
          rowKey="id"
          columns={filteredColumns}
          dataSource={dataSource}
          pagination={false} // Disable built-in pagination
          loading={status === 'loading'}
          scroll={{ x: '1650px' }}
          onChange={handleTableChange}
        />
      </div>

      <Pagination
        current={page}
        pageSize={pagesize}
        total={Outwardcount}
        showSizeChanger
        onShowSizeChange={handlePageSizeChange}
        pageSizeOptions={['20', '50', '100']}
        showTotal={total => `Total ${total} items`}
        onChange={handlePageChange}
        locale={{ items_per_page: 'Items / Page' }}
      />


    </div>
  );
}

export default BundleOutWardList;
